import { MmcDataSource } from './mmc-data-source';

const initDataSource = MmcDataSource.init;

export const useDataSourceInitializer = ({ scope, serverContext }) => {
  initDataSource({
    host: serverContext.ServicesEndpoints.MmcAPI,
    // host: `${configs.hosts.dev}/ODataApi/`, // toggle comment for local development
    oDataToken: serverContext.Token,
    aid: scope.values.aid,
    cid: serverContext.CurrentAccount.AdvertiserCustomerID,
    uid: scope.values.uid,
    error(xhr) {
      if (xhr && (xhr.status === 401)) {
        const domain = serverContext.NonAzureDomain || '';
        window.location.href = `${domain}/default.aspx?reason=1&msg=sessionexpired`;
      }
    },
  });
};
